import { render, staticRenderFns } from "./BatchStatisticsDialog.vue?vue&type=template&id=12a17695&scoped=true&"
import script from "./BatchStatisticsDialog.vue?vue&type=script&lang=js&"
export * from "./BatchStatisticsDialog.vue?vue&type=script&lang=js&"
import style0 from "./BatchStatisticsDialog.vue?vue&type=style&index=0&id=12a17695&scoped=true&lang=scss&"
import style1 from "./BatchStatisticsDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a17695",
  null
  
)

export default component.exports